export const mockParkingData = {
  "data": {
    "site": {
      "parkingSpaces": {
        "nodes": [
          {
            "name": "A004",
            "id": 17467,
            "isEnabled": true,
            "siteLevel": {
              "id": 166,
              "displayName": "Level 1"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T13:54:24+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Old Spaghetti Factory",
                    "ledRgbaValue": 16711680
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T13:54:24+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": {
                      "plate": "twr345",
                      "score": "0.996"
                    },
                    "vehicleRecognitionPlateRegion": {
                      "region": "us-in",
                      "score": "0.864"
                    },
                    "vehicleRecognitionMakeModel": {
                      "make": "Dodge",
                      "model": "Grand Caravan",
                      "score": "0.930"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Rear",
                      "score": "0.937"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "A006",
            "id": 17468,
            "isEnabled": true,
            "siteLevel": {
              "id": 166,
              "displayName": "Level 1"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T11:09:58+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Old Spaghetti Factory",
                    "ledRgbaValue": 16711680
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T11:09:58+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": null,
                    "vehicleRecognitionPlateRegion": null,
                    "vehicleRecognitionMakeModel": {
                      "make": "Chevrolet",
                      "model": "Traverse",
                      "score": "0.324"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Rear",
                      "score": "0.943"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "A008",
            "id": 17470,
            "isEnabled": true,
            "siteLevel": {
              "id": 166,
              "displayName": "Level 1"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T10:40:52+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Old Spaghetti Factory",
                    "ledRgbaValue": 16711680
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T10:40:52+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": null,
                    "vehicleRecognitionPlateRegion": null,
                    "vehicleRecognitionMakeModel": {
                      "make": "generic",
                      "model": "Unknown",
                      "score": "0.102"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Rear",
                      "score": "0.727"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "A003",
            "id": 17474,
            "isEnabled": true,
            "siteLevel": {
              "id": 166,
              "displayName": "Level 1"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T08:20:51+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Regular",
                    "ledRgbaValue": 65280
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T08:20:51+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": null,
                    "vehicleRecognitionPlateRegion": null,
                    "vehicleRecognitionMakeModel": {
                      "make": "Toyota",
                      "model": "RAV4",
                      "score": "0.958"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Front",
                      "score": "0.921"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "A010",
            "id": 17476,
            "isEnabled": true,
            "siteLevel": {
              "id": 166,
              "displayName": "Level 1"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T14:12:59+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Old Spaghetti Factory",
                    "ledRgbaValue": 16711680
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T14:12:59+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": {
                      "plate": "84300y",
                      "score": "0.928"
                    },
                    "vehicleRecognitionPlateRegion": {
                      "region": "us-in",
                      "score": "0.972"
                    },
                    "vehicleRecognitionMakeModel": {
                      "make": "Chevrolet",
                      "model": "Equinox",
                      "score": "0.614"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Rear",
                      "score": "0.939"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "A014",
            "id": 17479,
            "isEnabled": true,
            "siteLevel": {
              "id": 166,
              "displayName": "Level 1"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T14:43:23+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Old Spaghetti Factory",
                    "ledRgbaValue": 16711680
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T14:43:23+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": {
                      "plate": "730zsl",
                      "score": "0.996"
                    },
                    "vehicleRecognitionPlateRegion": {
                      "region": "us-in",
                      "score": "0.948"
                    },
                    "vehicleRecognitionMakeModel": {
                      "make": "Honda",
                      "model": "Civic",
                      "score": "0.953"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Rear",
                      "score": "0.926"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "B035",
            "id": 17557,
            "isEnabled": true,
            "siteLevel": {
              "id": 167,
              "displayName": "Level 2"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T08:05:25+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Regular",
                    "ledRgbaValue": 419364864
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T08:05:25+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": null,
                    "vehicleRecognitionPlateRegion": null,
                    "vehicleRecognitionMakeModel": {
                      "make": "Ford",
                      "model": "Super Duty",
                      "score": "0.938"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Front",
                      "score": "0.919"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "B045",
            "id": 17567,
            "isEnabled": true,
            "siteLevel": {
              "id": 167,
              "displayName": "Level 2"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-16T16:00:12+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Regular",
                    "ledRgbaValue": 419364864
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-16T16:00:12+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": {
                      "plate": "bss",
                      "score": "0.900"
                    },
                    "vehicleRecognitionPlateRegion": {
                      "region": "gb",
                      "score": "0.137"
                    },
                    "vehicleRecognitionMakeModel": {
                      "make": "Ford",
                      "model": "Super Duty",
                      "score": "0.865"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Front",
                      "score": "0.935"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "B049",
            "id": 17571,
            "isEnabled": true,
            "siteLevel": {
              "id": 167,
              "displayName": "Level 2"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-16T20:26:53+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Regular",
                    "ledRgbaValue": 419364864
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-16T20:26:53+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": {
                      "plate": "6371",
                      "score": "0.999"
                    },
                    "vehicleRecognitionPlateRegion": {
                      "region": "us-oh",
                      "score": "0.094"
                    },
                    "vehicleRecognitionMakeModel": {
                      "make": "Ford",
                      "model": "F-150",
                      "score": "0.516"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Rear",
                      "score": "0.932"
                    }
                  }
                }
              ]
            }
          },
          {
            "name": "B020",
            "id": 17542,
            "isEnabled": true,
            "siteLevel": {
              "id": 167,
              "displayName": "Level 2"
            },
            "parkingSpaceDataPoints": {
              "nodes": [
                {
                  "occupancyStatus": 2,
                  "period": {
                    "start": {
                      "value": "2025-07-17T11:07:35+00:00"
                    },
                    "end": null
                  },
                  "parkingAttribute": {
                    "displayName": "Electric Vehicle",
                    "ledRgbaValue": 16711680
                  }
                }
              ]
            },
            "parkingSpaceVehicleSessions": {
              "nodes": [
                {
                  "period": {
                    "start": {
                      "value": "2025-07-17T11:07:35+00:00"
                    },
                    "end": null
                  },
                  "parkingSpaceVehicleSessionBestAttribute": {
                    "vehicleRecognitionPlate": {
                      "plate": "553dia",
                      "score": "0.998"
                    },
                    "vehicleRecognitionPlateRegion": {
                      "region": "us-in",
                      "score": "0.303"
                    },
                    "vehicleRecognitionMakeModel": {
                      "make": "Chevrolet",
                      "model": "Camaro",
                      "score": "0.193"
                    },
                    "vehicleRecognitionOrientation": {
                      "orientation": "Rear",
                      "score": "0.940"
                    }
                  }
                }
              ]
            }
          }
        ]
      }
    }
  }
};